module.exports = __webpack_public_path__ + "static/media/mascot.bcd156ca.svg";